import type { Configuration, Control } from '@repo/api-gw-sdk';
import {
  ListControlsApi,
  CreateControlApi,
  UpdateControlApi,
  DeleteControlApi,
} from '@repo/api-gw-sdk';
import type { ColumnSort, PaginationState } from '@tanstack/react-table';

import type { HttpClient } from './httpClient';

const baseUrl = '/controls';

export const controls = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const listControlsApi = new ListControlsApi(config);
  const createControlApi = new CreateControlApi(config);
  const updateControlApi = new UpdateControlApi(config);
  const deleteControlApi = new DeleteControlApi(config);

  return {
    useList: (pagination?: PaginationState, sorting?: ColumnSort) =>
      httpClient.execute(
        listControlsApi.listControls.bind(listControlsApi),
        baseUrl,
        '',
        currentProjectId,
        pagination?.pageIndex,
        pagination?.pageSize,
        sorting && `${sorting.id}:${sorting.desc ? 'desc' : 'asc'}`
      ),
    useHasControls: () => {
      const { data, ...rest } = httpClient.execute(
        listControlsApi.listControls.bind(listControlsApi),
        baseUrl,
        'hasControls',
        currentProjectId,
        0,
        1
      );
      return { ...rest, data: (data?.controls?.length ?? 0) > 0 };
    },
    create: (control: Control) =>
      createControlApi.createControl(currentProjectId, control),
    update: (control: Control) =>
      updateControlApi.updateControl(currentProjectId, control.id, control),
    delete: (controlId: string) =>
      deleteControlApi.deleteControl(currentProjectId, controlId),
  };
};
